import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Ana Paula Mendes',
      age: '34 anos',
      result: 'Perdeu 18kg em 4 meses',
      text: 'Sempre lutei contra o peso e tentei diversas dietas sem sucesso. No instituto, encontrei um programa personalizado que realmente funciona. A equipe é maravilhosa, me acompanhou em cada etapa e os resultados superaram todas as minhas expectativas. Hoje me sinto confiante e feliz com meu corpo!',
      image: 'https://public.readdy.ai/ai/img_res/78ce23fc12b80948dc4b9bf2dcc3d99d.jpg',
      rating: 5
    },
    {
      name: 'Carla Fernandes',
      age: '42 anos',
      result: 'Rejuvenescimento facial completo',
      text: 'Os tratamentos faciais transformaram minha pele completamente. Estava com sinais de envelhecimento muito evidentes e me sentia insegura. Após os procedimentos recomendados pela Dra. Juliana, minha pele está radiante, firme e com aparência muito mais jovem. Recebo elogios todos os dias!',
      image: 'https://readdy.ai/api/search-image?query=elegant%20woman%2042%20years%20old%20with%20beautiful%20rejuvenated%20skin%20smiling%20portrait%20warm%20earth%20tones%20beige%20brown%20background%20natural%20lighting%20sophisticated%20appearance%20clean%20simple%20background%20beauty%20transformation&width=400&height=400&seq=testimonial-002&orientation=squarish',
      rating: 5
    },
    {
      name: 'Beatriz Santos',
      age: '29 anos',
      result: 'Modelagem corporal e redução de medidas',
      text: 'Depois da gravidez, meu corpo mudou muito e eu não conseguia voltar à forma anterior. Os tratamentos de modelagem corporal foram incríveis! Eliminei a flacidez, reduzi medidas e recuperei minha autoestima. O atendimento é impecável e os resultados são realmente visíveis. Super recomendo!',
      image: 'https://readdy.ai/api/search-image?query=young%20woman%2029%20years%20old%20fit%20and%20confident%20after%20body%20contouring%20smiling%20portrait%20warm%20beige%20brown%20background%20natural%20lighting%20healthy%20appearance%20clean%20simple%20background%20wellness%20transformation&width=400&height=400&seq=testimonial-003&orientation=squarish',
      rating: 5
    },
    {
      name: 'Juliana Almeida',
      age: '38 anos',
      result: 'Perdeu 22kg e ganhou qualidade de vida',
      text: 'Minha vida mudou completamente após iniciar o programa de emagrecimento. Além de perder peso, aprendi a ter uma relação saudável com a comida. A equipe multidisciplinar me deu todo o suporte necessário. Hoje tenho mais energia, disposição e me sinto linda! Gratidão eterna a todos!',
      image: 'https://readdy.ai/api/search-image?query=confident%20woman%2038%20years%20old%20healthy%20lifestyle%20after%20weight%20loss%20smiling%20portrait%20warm%20earth%20tones%20beige%20brown%20background%20natural%20lighting%20vibrant%20appearance%20clean%20simple%20background%20wellness%20success&width=400&height=400&seq=testimonial-004&orientation=squarish',
      rating: 5
    },
    {
      name: 'Renata Costa',
      age: '45 anos',
      result: 'Tratamento anti-idade completo',
      text: 'Estava buscando tratamentos que realmente funcionassem para combater os sinais da idade. Encontrei no instituto a solução perfeita! Os procedimentos são modernos, seguros e os resultados são naturais. Minha pele está incrível e me sinto rejuvenescida. A equipe é extremamente profissional e atenciosa!',
      image: 'https://readdy.ai/api/search-image?query=elegant%20mature%20woman%2045%20years%20old%20with%20youthful%20appearance%20smiling%20portrait%20warm%20beige%20brown%20background%20natural%20lighting%20sophisticated%20style%20clean%20simple%20background%20anti%20aging%20success%20story&width=400&height=400&seq=testimonial-005&orientation=squarish',
      rating: 5
    },
    {
      name: 'Patrícia Lima',
      age: '31 anos',
      result: 'Tratamento de celulite e flacidez',
      text: 'Sempre tive complexo com celulite e flacidez nas pernas. Os tratamentos corporais foram revolucionários! A tecnologia utilizada é de ponta e os profissionais são extremamente capacitados. Minha pele está lisa, firme e uniforme. Finalmente posso usar shorts e vestidos com total confiança!',
      image: 'https://readdy.ai/api/search-image?query=happy%20woman%2031%20years%20old%20confident%20after%20cellulite%20treatment%20smiling%20portrait%20warm%20earth%20tones%20beige%20brown%20background%20natural%20lighting%20radiant%20appearance%20clean%20simple%20background%20body%20transformation&width=400&height=400&seq=testimonial-006&orientation=squarish',
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="depoimentos" className="py-32 bg-gradient-to-b from-[#F8F6F4] to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block px-6 py-2 bg-[#915726]/10 rounded-full mb-6">
            <span className="text-[#915726] text-sm font-semibold tracking-wider uppercase">Depoimentos</span>
          </div>
          <h2
            className="text-5xl md:text-6xl font-bold text-[#676028] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Histórias de Transformação
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Histórias reais de transformação e sucesso de nossos clientes
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
            <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="relative w-full h-96 md:h-auto">
                <img
                  src={testimonials[currentIndex].image}
                  alt={testimonials[currentIndex].name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#915726]/90 via-transparent to-transparent"></div>
                <div className="absolute bottom-8 left-8 right-8">
                  <p className="text-white font-bold text-xl mb-2">
                    {testimonials[currentIndex].result}
                  </p>
                  <div className="flex gap-1">
                    {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-xl text-white"></i>
                    ))}
                  </div>
                </div>
              </div>

              <div className="p-10 md:p-12 flex flex-col justify-center">
                <div className="mb-6">
                  <i className="ri-double-quotes-l text-5xl text-[#915726]/20"></i>
                </div>

                <p className="text-gray-700 text-base leading-relaxed mb-8">
                  {testimonials[currentIndex].text}
                </p>

                <div className="border-t border-gray-200 pt-6">
                  <h4
                    className="text-2xl font-bold text-[#676028] mb-1"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {testimonials[currentIndex].name}
                  </h4>
                  <p className="text-[#915726] text-sm font-medium">
                    {testimonials[currentIndex].age}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-16 w-14 h-14 flex items-center justify-center bg-white rounded-full shadow-xl hover:bg-[#915726] hover:text-white transition-all duration-300 cursor-pointer border border-gray-100"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-16 w-14 h-14 flex items-center justify-center bg-white rounded-full shadow-xl hover:bg-[#915726] hover:text-white transition-all duration-300 cursor-pointer border border-gray-100"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          <div className="flex justify-center mt-10 gap-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex ? 'bg-[#915726] w-10' : 'bg-gray-300 w-2'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}